export default __webpack_public_path__ + "static/media/platform.496c4cbc.svg";